clamp = function (v, a, z) {
  return Math.min(Math.max(v, a), z);
}


parseQueryString = () => {

  let string;

  if (location.search && location.search !== "") {

    let query = location.search.substring(1);
    string = JSON.parse('{"' + decodeURI(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
  }

  return string;
};

function getViewport() {
  let e = window, a = 'inner';
  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return { width: e[a + 'Width'], height: e[a + 'Height'] };
};

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function hasClass(target, className) {
  return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
}

remove = (array, element) => {
  return array.filter(e => e !== element);
};
